export default class MapBounds {
    constructor(props={}) {
        this.sw = props.sw;
        this.ne = props.ne;
    }
}